import { z } from 'zod';
import { entryQuestionnaireReqDto } from './entry-questionnaire.req.dto';

export const entryQuestionnaireResDto = entryQuestionnaireReqDto;

export type EntryQuestionnaireResDtoType = z.infer<
  typeof entryQuestionnaireReqDto
>;
